<template>
    <div class="wrapper">
        <div class="use">
			<!-- 以后可能有业务不显示云之谷logo，或更换成其他的logo -->
            <!-- <div class="content" :style="{'background':getBackground}"> -->
			<div class="content">
                <span class="logo">
					<!-- 右上角logo，以后可能有业务不显示云之谷logo，或更换成其他的logo -->
                    <img src="../assets/logo.png" alt="logo">
                </span>
                <div class="head">
                    <header></header>
                    <span class="title">{{name}}</span>
                </div>
                <div class="body">
                    <div class="code">
                        <div class="tip">券码有效期至{{expiredDate}},请您尽快完成券码使用,券码超过有效期未使用,服务商无法为您提供换券服务。</div>
                        <div class="qrcode" ref="qrCodeUrl"></div>
                    </div>
                    <div class="sec">请出示以上券码给门店工作人员</div>
					<div class="dec">网点存在变动可能，使用前请先确认服务网点信息</div>
					<div class="btn" v-if="ticket.productId == 29"><router-link to='/sjlhStore' class="button">查看服务网点</router-link></div>
					<div class="btn" v-else><router-link to='/xianfengsgStore' class="button">查看服务网点</router-link></div>
                </div>
                <div class="foot">
                    <h1>券码规则</h1>
                    <div v-html="ticket.regulation" class="tip"></div>
					<div v-for="item in ticket.supplierProductCaptionList" :key="item.id" class="caption">
                		<p v-if="item.showPictureCaptions === 1">{{ item.pictureCaptions }}</p>
                		<img v-if="item.imgPath && item.imgPath.length > 0" :src="item.imgPath" alt="">
                	</div>
                </div>
            </div>
        </div>
        <div class="use_loading" v-if="loading">
            <div class="loading">
                <img src="../assets/loading.png" alt="加载中">
            </div>
        </div>
    </div>
</template>
<script>
import QRCode from 'qrcodejs2'; //引入生成二维码插件
import JsBarcode from 'jsbarcode';
// var JsBarcode = require('jsbarcode');
export default {
    data(){
        return{
            loading:true,
            key:this.$route.query.key,
            mobile: this.$route.query.mobile,
            name:'',
            effectiveDate:'',
            expiredDate:'',
            ticket:{},
            regulation: '',
   //          used:false,
			// 默认有背景logo
			// getBackground: 'url:\'../assets/code_bg.png\' #fff center 20px no-repeat'
        }
    },
    mounted(){
        this.getTicket();
        // this.creatQrCode(this.key);
    },
    methods:{
        creatQrCode(val) {
            let qrcode = new QRCode(this.$refs.qrCodeUrl, {
                text: val,
                width: 178,
                height: 178,
                colorDark: '#000000',
                colorLight: '#ffffff',
                correctLevel: QRCode.CorrectLevel.H
            });
            this.loading = false;
        },
        getTicket(){
            const obj = {
                ticketNo:this.key,
                isVerify:'-1',
                mobile:this.mobile
            };
            this.$http.POST('productTicket/selectProductTicket',obj).then(res=>{
                // this.loading = false;
                if(res.code===0){
                    // name:this.$route.query.name,
                    // effectiveDate:this.$route.query.effectiveDate,
                    // expiredDate:this.$route.query.expiredDate,
                    // status:this.$route.query.status,
                    this.ticket = res.data;
                    this.name = this.ticket.ticketName;
                    this.effectiveDate = this.ticket.effectiveDate;
                    this.expiredDate = this.ticket.expiredDate;
                    this.regulation = this.ticket.regulation;
                    this.creatQrCode(this.ticket.outTicketPsw);
					// 以后可能需要不显示背景logo，判断条件到时候更换成后台返回的值去判断
					// if(this.used){
					// 	this.getStyle='#fff center 20px no-repeat';
					// }
                } else {
                    alert(res.msg);
                }
            });
        }
    }
}
</script>
<style lang="scss" scoped>
.wrapper{
    height: 100%;
    position: relative;
    .use{
        // height: 100%;
        background: #108EE9;
        padding: 30px 15px 15px 15px;
        box-sizing: border-box;
        min-height:100%;
        .content{
            background: #fff;
            border-radius: 4px;
            background: url('../assets/code_bg.png') #fff center 20px no-repeat;
            background-size: 305px 338px;
            min-height: 338px;
            position: relative;
            .logo{
                position: absolute;
                display: inline-block;
                right: 0;
                top: 0;
                img{
                    width: 51px;
                    height: 51px;
                }
            }
            .head{
                position: relative;
                height: 30px;
                width: 100%;
                display: flex;
                justify-content: center;
                header{
                    width: 190px;
                    border-top: 30px solid #2C78DC;
                    border-right: 12px solid transparent;
                    border-left:12px solid transparent;
                    box-sizing: border-box;
                    height: 30px;
                }
                .title{
                    font-size: 15px;
                    position: absolute;
                    top: 0;
                    left: 0;
                    color: #fff;
                    width: 100%;
                    height: 30px;
                    line-height: 30px;
                    text-align: center;
                }
            }
            .body{
                border-bottom:1px dashed #CCCCCC;
                p{
                    font-size: 15px;
                    color: #999999;
                    text-align: center;
                    padding-top: 10px;
                }
                h1{
                    font-size: 20px;
                    color: #333333;
                    text-align: center;
                    padding-top: 15px;
                }
                .code{
                    padding-top: 40px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    .qrcode{
                        padding-top: 20px;
                    }
                    .tip{
                        width:75%;
                        background:yellow;
                        font-size:12px;
                    }
                }
                .sec{
                    font-size: 15px;
                    color: #999999;
                    padding: 30px 0 15px 0;
                    text-align: center;
                }
                .dec{
                    font-size: 15px;
                    background: #FEFCEC;
                    padding: 10px 0;
                    color: #F76A24;
                    text-align: center;
                }
                .btn{
                    display: flex;
                    justify-content: center;
                    padding: 15px 0 30px 0;
                    .button{
                        font-size: 15px;
                        width: 200px;
                        height: 40px;
                        line-height: 40px;
                        text-align: center;
                        color: #fff;
                        background: #1E87FC;
                        border-radius: 4px;
                    }
                }
            }
            .foot{
                padding: 24px 17px;
                h1{
                    font-size: 20px;
                    color: #333333;
                    font-weight: bold;
                }
                .tip{
                    color: #666666;
                    font-size: 15px;
                    line-height: 28px;
                }
            	.caption{
            		img{
            		    max-width:100%;
            		    padding:5px 0;
            		}
            		p{
            		    color: #666666;
            		    font-size: 15px;
            		    line-height: 28px;
            		}
            	}
            }
        }
    }
    
    .use_loading{
        position: absolute;
        height: 100%;
        width: 100%;
        z-index: 11;
        left: 0;
        top: 0;
        .loading{
            width: 100%;
            height: 100%;
            background: rgba(0,0,0,0.5);
            display: flex;
            justify-content: center;
            align-items: center;
            img{
                width:50px;
                height: 50px;
                animation:turn .8s linear infinite;      
                margin: 100px auto;
            }
            @keyframes turn{
                0%{-webkit-transform:rotate(0deg);}
                25%{-webkit-transform:rotate(90deg);}
                50%{-webkit-transform:rotate(180deg);}
                75%{-webkit-transform:rotate(270deg);}
                100%{-webkit-transform:rotate(360deg);}
            }
        }
    } 
}
</style>